var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Welcome "),_c('font',{attrs:{"color":"#af0f6a"}},[_vm._v(_vm._s(_vm.user.username))])],1),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("This is the home page of Romeflex Market Platform")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427d2248","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 